
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[[...index]]",
      function () {
        return require("private-next-pages/blog/[[...index]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[[...index]]"])
      });
    }
  